module.exports = __webpack_public_path__ + "img/exame.d2561f9e.png";